import React from 'react';
import PropTypes from 'prop-types';
import { Pagination } from 'react-bootstrap/lib';
import RevisionItem from './RevisionItem';

const PER_PAGE = 10;
const SURROUND_PAGES = 5;

function RevisionList(props) {
  const { revisions, fetching, setPage, page } = props;

  if ((!revisions || !revisions.data.length) && !fetching) {
    return <h4 className="text-center">No changes found</h4>;
  }

  // Generate pagination items
  const totalPages = revisions ? Math.ceil(revisions.total / PER_PAGE) : 0;
  const paginationItems = [];
  for (
    let p = Math.max(1, page - SURROUND_PAGES);
    p <= Math.min(totalPages, page + SURROUND_PAGES);
    p += 1
  ) {
    paginationItems.push(
      <Pagination.Item key={p} active={page === p} onClick={() => setPage(p)}>
        {p}
      </Pagination.Item>,
    );
  }
  paginationItems.unshift(
    <Pagination.Prev
      key="prev"
      disabled={page === 1}
      onClick={() => setPage(Math.max(1, page - 1))}
    />,
  );
  paginationItems.push(
    <Pagination.Next
      key="next"
      disabled={page === totalPages}
      onClick={() => setPage(Math.min(totalPages, page + 1))}
    />,
  );

  return (
    <div>
      {revisions &&
        revisions.data.map(revision => (
          <RevisionItem key={revision.id} revision={revision} />
        ))}
      {totalPages > 1 && <Pagination>{paginationItems}</Pagination>}
    </div>
  );
}

RevisionList.propTypes = {
  page: PropTypes.number,
  setPage: PropTypes.func,
  revisions: PropTypes.object,
  fetching: PropTypes.bool,
};

export default RevisionList;
